
// import helpers form user_data_personalizer 
import { removeNullCharacters } from '../../shared/utils/user_data_personaliser.js';


export function anonymize_chatgpt_data(
    conversations,
    shared_conversations,
    message_feedbacks,
    uploaded_images
) {
    let anonymized_user_object = {
        conversations: removeNullCharacters(conversations)
    };

    if (shared_conversations !== null) {
        anonymized_user_object['shared_conversations'] = removeNullCharacters(shared_conversations);
    }
    if (message_feedbacks !== null) {
        anonymized_user_object['message_feedbacks'] = removeNullCharacters(message_feedbacks);
    }
    if (uploaded_images !== null) {
        anonymized_user_object['uploaded_images'] = uploaded_images;
    }

    return anonymized_user_object;
}
